import { Component, OnInit } from "@angular/core";
import { Inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { AppConfig } from "src/app/config";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";

@Component({
  selector: "app-metarelatedlistfield",
  templateUrl: "./metarelatedlistfield.component.html",
  styleUrls: ["./metarelatedlistfield.component.scss"]
})
export class MetarelatedlistfieldComponent implements OnInit {
  // @Output() fieldsDoneEmitter: EventEmitter<any[]> = new EventEmitter<any[]>();
  uniqueIdentifier: string;
  metaObjectId: any;
  objectlinkobject: "";
  followup: "";
  metaObjectName = "";
  relatedFilters = [];
  isLoading = false;
  isError = false;
  errorMessage = "";
  fields = [];
  selectedLocation = "";
  selectedViewType = "";
  selectedSortField = "";
  selectedSortOrder = "";
  selectedUploadtype = "";
  selectEnableVersioning = "";
  selectLinkedObject = "";
  selectContraField = "";
  selectContraReferenceFields = "";

  selectedRelatedGroup = "";
  iconName: any;
  fieldname = "";
  referencefieldname = "";
  fieldid = "";
  childrelationshipname = "";
  relatedlistlabel = "";

  fieldsToDo: any[];
  fieldsDone: any[];
  index: any;
  metabuttonList = [];
  Buttonlist = [];
  ButtonsToDo = [];
  ButtonsDone = [];

  ViewfieldsToDo: any[];
  ViewfieldsDone: any[];

  ViewButtonsToDo = [];
  ViewButtonsDone = [];

  guid: GUID;
  filterForm: FormGroup;
  filteritems: FormArray;
  versioningForm: FormGroup;
  linkobjectForm: FormGroup;
  picklistValueList = [];
  fieldList = [];
  sortFieldList = [];
  operatorList = [];
  checkboxValueList = [
    { label: "True", value: true },
    { label: "False", value: false }
  ];

  contraRefInput: string = "";
  contraRefList: string[] = [];

  addContraRef() {
    const value = this.contraRefInput.trim();

    if (value !== "" && !this.contraRefList.includes(value)) {
      this.contraRefList.push(value);
    }
    this.contraRefInput = ""; // clear input
  }

  removeContraRef(index: number) {
    this.contraRefList.splice(index, 1);
  }
  // contrareferencefields: string = "";
  // contraRefList: string[] = [];
  // contraRefInput: string = "";

  // addContraRef() {
  //   const value = this.contraRefInput.trim();
  //   if (value !== "" && !this.contraRefList.includes(value)) {
  //     this.contraRefList.push(value);
  //     this.contraRefInput = ""; // clear input box
  //   }
  // }

  // removeContraRef(index: number) {
  //   this.contraRefList.splice(index, 1);
  // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: DataService,
    private fb: FormBuilder,
    private appConfig: AppConfig,

    private dialogRef: MatDialogRef<MetarelatedlistfieldComponent>
  ) {
    console.log("Dialog Data:", data);
    this.metaObjectId = data.metaObjectId;
    this.metaObjectName = data.metaObjectname;
    this.uniqueIdentifier = data.uniqueIdentifier;
    this.index = data.index;
    this.objectlinkobject = data.linkedobject;
    this.followup = data.followup;

    console.log("objectlinkobject", this.objectlinkobject);
    console.log("followup", this.followup);

    console.log("fieldId received in dialog:", data);
    console.log("Retrieved Data", this.data.retrievedData);
    console.log("this.metaObjectName", this.metaObjectName);
    // console.log("Linkobject received:", this.linkobject);

    // this.fieldsDone = this.data.retrievedData[0].selectedLookupFields;
    this.data.retrievedData.forEach((item: any) => {
      console.log("****item", item);
      console.log(item.metaobjectid);
      console.log(this.metaObjectId);

      const fieldName = item.fieldname || item.lookupfield.metafieldname;
      const referencefieldName =
        item.referencefieldname || item.lookupfield.referencefieldname;
      console.log("referencefieldName", referencefieldName);
      const fieldId = item.fieldid || item.lookupfield.fieldid;
      const childRelationshipName =
        item.childrelationshipname ||
        item.lookupfield.attributes.childrelationshipname;
      const relatedListLabel =
        item.relatedlistlabel || item.lookupfield.attributes.relatedlistlabel;
      if (item.metaobjectid === this.metaObjectId) {
        this.selectedLocation = item.location;
        this.selectedViewType = item.viewtype;
        this.selectedSortField = item.sortfield;
        this.selectedSortOrder = item.sortorder;
        this.selectedUploadtype = item.uploadtype;
        this.selectEnableVersioning = item.enableversioning;
        this.selectLinkedObject = item.linkedobject;
        this.selectContraField = item.contrafield;
        // this.selectContraReferenceFields = item.contrareferencefields;
        this.contraRefList = item.contrareferencefields
          ? item.contrareferencefields.split(",")
          : [];
        this.selectedRelatedGroup = item.relatedgroupname;
        this.iconName = item.iconname;
        this.fieldname = fieldName;
        this.referencefieldname = referencefieldName;
        this.fieldid = fieldId;
        this.childrelationshipname = childRelationshipName;
        this.relatedlistlabel = relatedListLabel;

        if (!this.fieldsDone) {
          this.fieldsDone = [];
        }
        this.fieldsDone = this.fieldsDone.concat(item.selectedLookupFields);

        if (!this.ButtonsDone) {
          this.ButtonsDone = [];
        }
        this.ButtonsDone = this.ButtonsDone.concat(item.selectedLookupButtons);
      }

      if (item.metaobjectid === this.metaObjectId) {
        this.selectedLocation = item.location;
        this.selectedViewType = item.viewtype;
        this.selectedSortField = item.sortfield;
        this.selectedSortOrder = item.sortorder;
        this.selectedUploadtype = item.uploadtype;
        this.selectEnableVersioning = item.enableversioning;
        this.selectLinkedObject = item.linkedobject;
        this.selectContraField = item.contrafield;
        // this.selectContraReferenceFields = item.contrareferencefields;
        this.contraRefList = item.contrareferencefields
          ? item.contrareferencefields.split(",")
          : [];
        this.selectedRelatedGroup = item.relatedgroupname;

        this.iconName = item.iconname;
        this.fieldname = fieldName;
        this.referencefieldname = referencefieldName;
        this.fieldid = fieldId;
        this.childrelationshipname = childRelationshipName;
        this.relatedlistlabel = relatedListLabel;

        if (!this.ViewfieldsDone) {
          this.ViewfieldsDone = [];
        }
        this.ViewfieldsDone = this.ViewfieldsDone.concat(
          item.selectedViewFields
        );

        if (!this.ViewButtonsDone) {
          this.ViewButtonsDone = [];
        }
        this.ViewButtonsDone = this.ViewButtonsDone.concat(
          item.selectedViewButtons
        );
      }
    });

    console.log(this.fieldsDone);
    console.log(this.ButtonsDone);

    console.log("fieldName received in dialog:", this.metaObjectName);
    console.log("metaObjectId received in dialog:", this.metaObjectId);
  }
  ngOnInit() {
    this.getAllMetaFields();
    this.getMetabuttons();
    this.guid = new GUID();

    this.getAllMetaFields().then((res) => {
      console.log("response1111", res);

      if (this.relatedFilters.length == 0) {
        this.addFilterItem("", "", "", [], "", "");
        this.addFilterItem("", "", "", [], "", "");
        this.addFilterItem("", "", "", [], "", "");
      }
    }); //getMetaFieldsForSelection()
    this.filterForm = this.fb.group({
      metaobjectid: "",
      metaobjectname: "",
      filteritems: this.fb.array([]),
      filterlogic: ""
    });
    this.versioningForm = this.fb.group({
      enableversioning: false
    });

    this.linkobjectForm = this.fb.group({
      linkedobject: false
    });

    // this.selectedUploadtype = "directupload";
    // this.selectEnableVersioning = "false";
    //create operator type picklist from operatortypes

    for (let i = 0; i < this.appConfig.operatorTypes.length; i++) {
      //convert to titecase
      var strLabel = this.appConfig.operatorTypes[i];
      strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
      this.operatorList.push({
        value: this.appConfig.operatorTypes[i],
        label: strLabel
      });
    }
  }

  FieldSelection(field: any) {
    field.selected = !field.selected;
  }
  FieldDeSelection(field: any) {
    field.selected = !field.selected;
  }
  moveSelectedFieldsToDone() {
    const selectedFields = this.fieldsToDo.filter((field) => field.selected);
    this.fieldsDone.push(...selectedFields);
    this.fieldsToDo = this.fieldsToDo.filter((field) => !field.selected);
    selectedFields.forEach((field) => (field.selected = false));
    console.log(this.fieldsDone);
  }

  moveSelectedFieldsToDo() {
    const selectedFields = this.fieldsDone.filter((field) => field.selected);
    this.fieldsToDo.push(...selectedFields);
    this.fieldsDone = this.fieldsDone.filter((field) => !field.selected);
    selectedFields.forEach((field) => (field.selected = false));
  }

  ButtonSelection(button: any) {
    button.selected = !button.selected;
  }
  ButtonDeSelection(button: any) {
    button.selected = !button.selected;
  }

  moveSelectedButtonsToDone() {
    const selectedButtons = this.ButtonsToDo.filter(
      (button) => button.selected
    );
    this.ButtonsDone.push(...selectedButtons);
    this.ButtonsToDo = this.ButtonsToDo.filter((button) => !button.selected);
    selectedButtons.forEach((button) => (button.selected = false));
  }

  moveSelectedButtonsToDo() {
    const selectedButtons = this.ButtonsDone.filter(
      (button) => button.selected
    );
    this.ButtonsToDo.push(...selectedButtons);
    this.ButtonsDone = this.ButtonsDone.filter((button) => !button.selected);
    selectedButtons.forEach((button) => (button.selected = false));
  }

  // For View All

  ViewFieldSelection(viewfield: any) {
    viewfield.selected = !viewfield.selected;
  }
  ViewFieldDeSelection(viewfield: any) {
    viewfield.selected = !viewfield.selected;
  }
  moveSelectedViewFieldsToDone() {
    const selectedViewFields = this.ViewfieldsToDo.filter(
      (viewfield) => viewfield.selected
    );
    this.ViewfieldsDone.push(...selectedViewFields);
    this.ViewfieldsToDo = this.ViewfieldsToDo.filter(
      (viewfield) => !viewfield.selected
    );
    selectedViewFields.forEach((viewfield) => (viewfield.selected = false));
  }

  moveSelectedViewFieldsToDo() {
    const selectedViewFields = this.ViewfieldsDone.filter(
      (viewfield) => viewfield.selected
    );
    this.ViewfieldsToDo.push(...selectedViewFields);
    this.ViewfieldsDone = this.ViewfieldsDone.filter(
      (viewfield) => !viewfield.selected
    );
    selectedViewFields.forEach((viewfield) => (viewfield.selected = false));
  }

  ViewButtonSelection(viewbutton: any) {
    viewbutton.selected = !viewbutton.selected;
  }
  ViewButtonDeSelection(viewbutton: any) {
    viewbutton.selected = !viewbutton.selected;
  }

  moveSelectedViewButtonsToDone() {
    const selectedViewButtons = this.ViewButtonsToDo.filter(
      (viewbutton) => viewbutton.selected
    );
    this.ViewButtonsDone.push(...selectedViewButtons);
    this.ViewButtonsToDo = this.ViewButtonsToDo.filter(
      (viewbutton) => !viewbutton.selected
    );
    selectedViewButtons.forEach((viewbutton) => (viewbutton.selected = false));
  }

  moveSelectedViewButtonsToDo() {
    const selectedViewButtons = this.ViewButtonsDone.filter(
      (viewbutton) => viewbutton.selected
    );
    this.ViewButtonsToDo.push(...selectedViewButtons);
    this.ViewButtonsDone = this.ViewButtonsDone.filter(
      (viewbutton) => !viewbutton.selected
    );
    selectedViewButtons.forEach((viewbutton) => (viewbutton.selected = false));
  }

  showContent = false;
  showButtonContent = false;
  showviewContent = false;
  showFilterContent = false;

  fieldtoggle() {
    this.showContent = !this.showContent;
    this.showButtonContent = !this.showButtonContent;
  }

  buttontoggle() {
    this.showButtonContent = !this.showButtonContent;
  }

  filtertoggle() {
    this.showFilterContent = !this.showFilterContent;
  }
  view() {
    this.showviewContent = !this.showviewContent;
  }
  fieldSelected(
    event: { id: any; fieldtype: any; options: string },
    index: number
  ) {
    console.log("fieldSelected");
    console.log("index", index);
    console.log("event", event);

    var i = 0;
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      if (i == index) {
        console.log("matching", c);
        c.get("fieldid").setValue(event.id);
        c.get("fieldtype").setValue(event.fieldtype);
        c.get("options").setValue(event.options);
        if (c.get("fieldoperator").value == "") {
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        if (event.options != "") {
          var arr = JSON.parse(event.options || "[]");
          this.picklistValueList[index] = arr;
          c.get("fieldoperator").setValue("equals"); //default operator set
        }
        c.get("fieldvalue").setValue("");
        break;
      }
      i++;
    }
  }

  addFilter(index: any) {
    if (this.filteritems != null && this.filteritems.length < 10) {
      this.addFilterItem("", "", "", "", "", "");
    }
  }

  removeFilter(index: any) {
    this.removeFilterItem(index);
  }

  createItem(
    id: any,
    name: any,
    ftype: any,
    opt: any,
    opr: any,
    vl: any,
    flogic: string
  ): FormGroup {
    return this.fb.group({
      //fieldlist: fldlist,
      //operatorlist: oplist,
      fieldid: id,
      fieldname: name,
      fieldtype: ftype,
      options: opt,
      fieldoperator: opr,
      fieldvalue: vl,
      filterlogic: flogic
    });
  }

  addFilterItem(
    id: string,
    name: string,
    ftype: string,
    opt: string | any[],
    opr: string,
    vl: string,
    flogic = "AND"
  ): void {
    this.filteritems = this.filterForm.get("filteritems") as FormArray;
    this.filteritems.push(
      this.createItem(id, name, ftype, opt, opr, vl, flogic)
    );
    this.picklistValueList.push([]);
  }

  removeFilterItem(index: number) {
    if (index > 0) {
      this.filteritems.removeAt(index);
    }
  }

  getAllMetaFields() {
    return new Promise((resolve, reject) => {
      console.log("MetaFields");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.metaObjectId,
            metaobjectname: this.metaObjectName
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaFields(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;
            this.fieldsToDo = this.fields;
            this.ViewfieldsToDo = this.fields;
            // this.fieldsDone = this.fieldsToDo.filter(field => field.fieldname === 'name');

            // Filter out the fields that are already done
            const doneFieldNames = this.fieldsDone.map(
              (field) => field.fieldname
            );
            this.fieldsToDo = this.fieldsToDo.filter(
              (field) => !doneFieldNames.includes(field.fieldname)
            );

            const doneFieldViewNames = this.ViewfieldsDone.map(
              (field) => field.fieldname
            );
            this.ViewfieldsToDo = this.ViewfieldsToDo.filter(
              (field) => !doneFieldViewNames.includes(field.fieldname)
            );

            this.fieldList.push({
              value: "",
              label: "--None--",
              fieldtype: "text",
              standard: true,
              options: [],
              id: ""
            });
            //create fieldlist from fields as readable form by selection control
            for (let i = 0; i < this.fields.length; i++) {
              var field = this.fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              //skip converted field if object is lead
              if (
                this.metaObjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              //convert to titecase
              var strLabel = field.labelname;

              strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
              this.fieldList.push({
                value: field.fieldname,
                label: strLabel,
                fieldtype: field.fieldtype,
                standard: field.standard,
                options: field.options,
                id: field.id
              });
            }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.errorMessage = res != null ? res.message : "No fields data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
          // this.metalayoutbutton.push(button);
        }
      );
    });
  }

  getMetabuttons() {
    return new Promise((resolve, reject) => {
      console.log("getMetabuttons");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metabutton: {
            metaobjectid: this.metaObjectId
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getMetaButtons(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.metabuttonList = res.data.metabuttons;
            this.ButtonsToDo = this.metabuttonList;
            this.ViewButtonsToDo = this.metabuttonList;
            console.log(this.ViewButtonsToDo);

            // this.metabuttonList.forEach((button) => {
            //   if (button.actiontype === "View" || button.actiontype === "New") {
            //     this.ButtonsToDo.push(button);
            //   }
            // });

            // Filter out the buttons that are already done

            this.ButtonsToDo = this.ButtonsToDo.filter((button) => {
              return !this.ButtonsDone.some(
                (doneButton) =>
                  doneButton.name === button.name &&
                  doneButton.buttontype === button.buttontype
              );
            });
            this.ViewButtonsToDo = this.ViewButtonsToDo.filter((button) => {
              return !this.ViewButtonsDone.some(
                (doneButton) =>
                  doneButton.name === button.name &&
                  doneButton.buttontype === button.buttontype
              );
            });

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metabuttons data!");
            this.errorMessage =
              res != null ? res.message : "No metabuttons data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  save() {
    var arrayControl = this.filterForm.get("filteritems") as FormArray;
    for (let c of arrayControl.controls) {
      var fieldId = c.get("fieldid").value;
      var fieldName = c.get("fieldname").value;
      var fieldType = c.get("fieldtype").value;

      var operator = c.get("fieldoperator").value;
      if (operator.toLowerCase().trim() == "--none--") operator = "";

      var value = c.get("fieldvalue").value;
      // if (value.toLowerCase().trim() == "--none--") value = "";
      if (value == "--none--") value = "";

      if (fieldId != "" && operator != "") {
        var relatedFilter = {
          id: this.guid.getGUID("metaprofilelayoutcriteria"),
          metaobjectid: this.metaObjectId,
          metafieldid: fieldId,
          fieldname: fieldName,
          fieldtype: fieldType,
          operator: operator,
          value: value,
          // filterlogic: c.get("filterlogic").value,
          filterlogic: this.filterForm.controls["filterlogic"].value
        };

        console.log(relatedFilter);
        //push it to array
        this.relatedFilters.push(relatedFilter);
      }
    }
    console.log("Selected Fields", this.fieldsDone);
    console.log("Selected Buttons", this.ButtonsDone);

    console.log("Selected ViewFields", this.ViewfieldsDone);
    console.log("Selected ViewButtons", this.ViewButtonsDone);

    const SelectedData = {
      fieldsDone: this.fieldsDone,
      ButtonsDone: this.ButtonsDone,
      location: this.selectedLocation,
      viewtype: this.selectedViewType,
      sortfield: this.selectedSortField,
      sortorder: this.selectedSortOrder,
      uploadtype: this.selectedUploadtype,
      enableversioning: this.selectEnableVersioning,
      linkedobject: this.selectLinkedObject,
      contrafield: this.selectContraField,
      // contrareferencefields: this.selectContraReferenceFields,
      contrareferencefields: this.contraRefList.join(","),
      relatedgroupname: this.selectedRelatedGroup,
      iconname: this.iconName,
      fieldname: this.fieldname,
      referencefieldname: this.referencefieldname,
      fieldid: this.fieldid,
      childrelationshipname: this.childrelationshipname,
      relatedlistlabel: this.relatedlistlabel,
      ViewfieldsDone: this.ViewfieldsDone,
      ViewButtonsDone: this.ViewButtonsDone,
      relatedFilters: this.relatedFilters
    };

    this.dialogRef.close(SelectedData);
    console.log("SelectedData ", SelectedData);

    // this.fieldsDoneEmitter.emit(this.fieldsDone);
  }

  cancel() {
    this.dialogRef.close();
  }
}
